var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SubscriptionEstimationResponse_1;
/* eslint-disable import/no-duplicates */
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './address';
export var EstimationResult;
(function (EstimationResult) {
    EstimationResult["OK"] = "ok";
    EstimationResult["AddressResolutionFailure"] = "addressResolutionFailure";
    EstimationResult["TaxResolutionFailure"] = "taxResolutionFailure";
    EstimationResult["OtherFailure"] = "otherFailure";
})(EstimationResult || (EstimationResult = {}));
const schema = {
    $id: 'urn:wisepipe-common-subscription:SubscriptionEstimationResponse',
    type: 'object',
    properties: {
        validatedBillingAddress: { $ref: 'urn:wisepipe-common-subscription:Address' },
        validatedShippingAddress: { $ref: 'urn:wisepipe-common-subscription:Address' },
        estimationResult: { type: 'string', enum: Object.values(EstimationResult) },
        subscriptionAmount: { type: 'number', minimum: 0 },
        taxRate: { type: 'number', minimum: 0 },
        taxAmount: { type: 'number', minimum: 0 },
        messages: {
            type: 'array',
            items: { type: 'string', minLength: 1 }
        }
    },
    required: ['estimationResult', 'subscriptionAmount', 'taxRate', 'taxAmount']
};
let SubscriptionEstimationResponse = SubscriptionEstimationResponse_1 = class SubscriptionEstimationResponse {
    constructor(validatedBillingAddress, validatedShippingAddress, estimationResult, subscriptionAmount, taxRate, taxAmount, messages) {
        this.validatedBillingAddress = validatedBillingAddress;
        this.validatedShippingAddress = validatedShippingAddress;
        this.estimationResult = estimationResult;
        this.subscriptionAmount = subscriptionAmount;
        this.taxRate = taxRate;
        this.taxAmount = taxAmount;
        this.messages = messages;
        JSON.validate(this, SubscriptionEstimationResponse_1);
    }
};
SubscriptionEstimationResponse = SubscriptionEstimationResponse_1 = __decorate([
    JsonSchema(schema)
], SubscriptionEstimationResponse);
export { SubscriptionEstimationResponse };
//# sourceMappingURL=subscriptionEstimationResponse.js.map